import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VariableDirective } from '../../helpers/directives/variable/variable.directive';

@NgModule({
  declarations: [VariableDirective],
  imports: [CommonModule],
  exports: [VariableDirective]
})
export class DirectiveModule {}
